<script>
const Hero = () =>
  import(/* webpackChunkName: "Hero" */ "../components/Hero.vue");

const IgLogin = () =>
  import(/* webpackChunkName: "IgLogin" */ "../components/IgLogin.vue");

// import IgDropDown from "@/components/IgDropDown";

export default {
  name: "Home",
  // components: { Hero, IgLogin, IgDropDown },
  components: { Hero, IgLogin },
  computed: {
    user() {
      return this.$store.getters["guicms/USER"];
    }
  },
  data() {
    return {};
  },
  methods: {
    async logout() {
      try {
        let { data } = await this.$api1().post("/user/logout", {});
        this.$store.dispatch("guicms/USER_GET");
      } catch (e) {
        console.log("logout.err: " + e.message);
      }
    }
  }
};
</script>
<template>
  <div>
    <hero v-if="user != null" :title="$t('msg.hello')"></hero>
    <div v-if="user != null" class="my-3">
      <!-- <div class="section">
        <div class="title">
          testing
        </div>
        <div>
          <IgDropDown title="Testing dropdown">
            <a href="#" class="dropdown-item has-text-centered">
              <span>Action 1</span>
            </a>
            <a href="#" class="dropdown-item has-text-centered">
              <span>Action 2</span>
            </a>
          </IgDropDown>
        </div>
      </div> -->

      <div class="menu-list has-text-centered" v-if="$store.getters['guicms/HASROLE'](['IGPMGR', 'IGPADM'])">
        <!-- <div class="menu-label">
          {{ $t("igadm.crel") }}
        </div> -->
        <router-link to="/gpCfg">Guest portal config</router-link>
        <router-link to="/cso"><span>{{ $t("igadm.ordermgm") }}</span>
          <b-icon icon="sync-alt" size="is-small"></b-icon>
          <!-- <b-icon
            icon="sync-alt"
            custom-class="fa-spin"
            size="is-small"
          ></b-icon> -->
          <span class="tag is-warning">
            demo/evaluation (changes in progress)</span>
        </router-link>
        <router-link to="/shopmgr">{{ $t("shop.shop") }} &amp;
          {{ $tc("shop.servoffer", 2) }}</router-link>
      </div>
      <div class="menu-list has-text-centered" v-if="
        $store.getters['guicms/HASROLE'](['ADMIN', 'SITEADMIN', 'TVSTATS'])
      ">
        <router-link to="/sitewatch-tvcw-stats">TVC watch-stats</router-link>
      </div>
      <div class="menu-list has-text-centered my-3"
        v-if="$store.getters['guicms/HASROLE'](['USER', 'ADMIN', 'CMSMGR'])">
        <div class="menu-label">
          GUI &amp; media
        </div>
        <router-link to="/guicms">{{ $t("igadm.infoitemsmenu") }}</router-link>
        <!-- <router-link to="/cview1">GUI preview</router-link> -->
        <router-link to="/guimediaplaylists" class="navbar-item">{{
          $tc("g.playlist", 2)
          }}</router-link>
      </div>

      <!-- <br /> -->

      <!-- <div class="menu-list has-text-centered" v-if="$store.getters['guicms/HASROLE']('TVMON','ADMIN','SURVEY','MSGMGR','EVTMGR','EVENTS','RECEPTION')"> -->
      <div class="menu-list has-text-centered">
        <div class="menu-label">
          SYSTEM
        </div>
        <router-link v-if="$store.getters['guicms/HASROLE'](['ADMIN', 'SITEADMIN'])" to="/sitecfg">Site
          config</router-link>
        <router-link v-if="$store.getters['guicms/HASROLE'](['MEDIA', 'ADMIN', 'CMSMGR', 'SIGMGR'])" to="/media">{{
          $t("g.medialib") }}</router-link>
        <template v-if="$store.getters['guicms/HASROLE']('TVMON')">
          <router-link to="/sitewatch-tvcl-overview">{{ $tc("g.tvcdev", 2) }} - {{ $t("g.overview") }}</router-link>
          <router-link to="/sitewatch-tvlist">{{ $tc("g.tvcdev", 2) }} - {{ $t("g.list") }}
          </router-link>
        </template>

        <router-link to="/sitewatch-tvclients"
          v-if="$store.getters['guicms/HASROLE'](['ADMIN', 'SITEADMIN', 'TVCMD0'])">{{
            $tc("g.tvcdev", 2) }} - {{ $t("g.mgmt") }}
        </router-link>
        <!-- <router-link to="/sitewatch-tvclmgrv2" v-if="$store.getters['guicms/HASROLE'](['ADMIN', 'SITEADMIN','TVCMD0'])"
          >{{ $tc("g.tvcdev", 2) }} - {{ $t("g.mgmt") }} V2
        </router-link> -->

        <template v-if="$store.getters['guicms/HASROLE'](['ADMIN', 'HSKPLOG'])">
          <router-link to="/hskpMbarLogs">Housekeeping logs - minibar</router-link>
          <router-link to="/hskpLog">Housekeeping logs</router-link>
        </template>

        <router-link v-if="$store.getters['guicms/HASROLE'](['ADMIN', 'HSKPADM'])" to="/hskp">Housekeeping</router-link>



        <router-link to="/tvcl-cfg" v-if="$store.getters['guicms/HASROLE'](['ADMIN', 'TVCFG', 'TVADM'])">{{
          $tc("g.tvcdev", 2, { n: "" }) }} -
          {{ $t("g.config") }}</router-link>


        <router-link to="/room-cfg" v-if="$store.getters['guicms/HASROLE'](['ADMIN', 'ROOMCFG'])">{{
          $tc("g.#room", 2, { n: "" }) }} -
          {{ $t("g.config") }}</router-link>


        <template v-if="$store.getters['guicms/HASROLE']('ADMIN', 'SITEADMIN')">

          <router-link to="/chpled">TV &amp; radio</router-link>
          <template v-if="$store.getters['guicms/HASROLE']('HTVCASTADM')">
            <router-link to="/htvcast-mgr">HTV CAST</router-link>
          </template>
          <!-- <router-link to="/tvphl-clones">CLONE Management </router-link> -->
          <router-link to="/tvphl-devmgr">Philips devices</router-link>
          <router-link to="/weatherloc">Weather</router-link>
          <router-link to="/sitewatch">Site-watch</router-link>
        </template>

        <router-link to="/surveys" v-if="$store.getters['guicms/HASROLE'](['SURVEY', 'ADMIN'])">{{ $tc("g.#survey", 2, {
          n: ""
        }) }}</router-link>

        <router-link to="/guestmsgs" v-if="$store.getters['guicms/HASROLE'](['ADMIN', 'MSGMGR'])">{{ $t("igadm.gcomm")
          }}</router-link>
        <router-link to="/newsbc" v-if="
          $store.getters['guicms/HASROLE']([
            'EVENTS',
            /* 'EVTMGR', */
            'ADMIN',
            'MSGMGR'
          ])
        " class="navbar-item">{{ $t("g.msgbroadcasts") }}</router-link>

        <router-link v-if="$store.getters['guicms/HASROLE'](['SIGMGR', 'SIGADM', 'ADMIN'])"
          to="/conference-cfg">Conference
          module config</router-link>

        <router-link to="/roomgroup-mgmt" v-if="$store.getters['guicms/HASROLE'](['ADMIN', 'ROOMGRP'])">{{
          $t("g.roomgroups") }}
          -
          {{ $t("g.config") }}</router-link>

        <router-link v-if="$store.getters['guicms/HASROLE'](['SIGMGR', 'SIGADM', 'ADMIN'])" to="/conference-planner">{{
          $t("g.evtplanner") }}: {{ $tc('g.#conference', 3, { n: '' }) }}</router-link>
        <router-link v-if="$store.getters['guicms/HASROLE'](['ADMIN', 'EVTS_WELC'])" to="/evtwelc-planner">{{
          $t("g.evtplanner")
          }}: {{ $t('g.custwelcome') }}</router-link>

        <router-link v-if="$store.getters['guicms/HASROLE'](['SIGMGR', 'SIGADM', 'ADMIN'])" to="/signage-planner">{{
          $t("g.mediainfoplanner") }}</router-link>

        <router-link v-if="$store.getters['guicms/HASROLE'](['SIGADM', 'ADMIN'])" to="/signage-adm">{{ $t("g.plrmgmt")
          }}</router-link>

        <template v-if="$store.getters['guicms/HASROLE'](['RECEPTION', 'ADMIN', 'FOLIOADM'])">
          <router-link to="/foliomgmt">Folio management</router-link>
        </template>

        <a v-if="$store.getters['guicms/HASROLE'](['ADMIN', 'SITEADMIN'])" class="link is-info" href="/user-mgmt">{{
          $tc("g.#user", 2, { n: "" }) }}</a>
      </div>
      <!-- <div class="notification is-warning has-text-centered">
        - Initial site-config not finished -
      </div> -->
    </div>
    <div class="has-text-centered">
      <br />
      <template v-if="user != null">
        <a @click="logout" class="button">{{ $t("auth.logout") }}</a>
      </template>
      <template v-else>
        <IgLogin></IgLogin>
        <!-- <p>
          {{$t('auth.login')}}
        </p> -->
        <div class="">
          <!-- <p cass="control"> -->
          <a href="/login" class="button">{{ $t("auth.login") }}</a>
          <!-- </p> -->
        </div>
      </template>
    </div>
    <div class="footer has-text-centered">
      HTV management ver. {{ igapp.ver }}
    </div>
  </div>
</template>
